import { FormControl as r } from "./form-control.js";
import { FormControlDescription as m } from "./form-control-description.js";
import { FormControlErrorMessage as t } from "./form-control-error-message.js";
import { FormControlLabel as e } from "./form-control-label.js";
const o = r;
o.Label = e;
o.Description = m;
o.ErrorMessage = t;
export {
  o as FormControl
};
